import React from "react";
import { Row, Breadcrumb } from "antd";
import { Link } from "react-router-dom";


export default function BreadcrumbComponent() {
  return (
    <Row>
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link to="/" > Dashboard</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          {" "}
          <Link to="/buyer-list" >Recommendations</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Buyer Details</Breadcrumb.Item>
      </Breadcrumb>
    </Row>
  );
}
